export default function getAnalyticsPreferencesData(user) {
  if (!user?.teacher) {
    return {};
  }

  return {
    experience_ux: 'v2',
  };
}
